// @flow

import React from "react";
import { route } from "@routes/helper";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import { View, Text, Button } from "@components";
import { getRouteClientIdParam } from "@selectors";
import { Page } from "react-page-layout";
import { getUserId } from "@modules/account/selectors";
import clientActionCreators from "@modules/client/actionCreator";
import * as clientsSelectors from "@modules/client/selectors";
import type { Client } from "@modules/client/types";
import actionCreators from "@modules/service/actionCreator";

type OwnProps = $Exact<{
  error: string,
}>;

type PropsFromState = $Exact<{
  isLoading?: boolean,
  client?: Client,
  clientId: number,
  currentUserId: number | null,
}>;

type PropsFromDispatch = $Exact<{
  getClient: typeof clientActionCreators.GetClient,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromState,
  ...PropsFromDispatch,
  ...PropsFromLocalize,
}>;

export const ErrorPage = (props: Props) => {
  function handleReportIssue() {
    window.location = route("SERVICE_DESK_URL");
  }
  return (
    <Page layout="dashboard" title={props.t("ERROR_TITLE")} extraProps={props} permissionId={{}}>
      <View flex="1" justifyContent="start" alignItems="center">
        <View gap={5} className="card  bg-light" padding={5}>
          <View>
            <Text type="h4">{props.t("ERROR_TITLE")}</Text>
          </View>
          <View>
            <Text>{props.t("ERROR_MESSAGE_LINE_1")}</Text>
          </View>
          <View alignItems="start">
            <Button
              color="pumpkin-orange"
              onClick={handleReportIssue}
              label={props.t("REPORT_ISSUE")}
            />
          </View>
        </View>
      </View>
    </Page>
  );
};

const LocalizedErrorPage = localize()(ErrorPage);

const mapStateToProps = (state, ownProps): PropsFromState => {
  const clientId = getRouteClientIdParam(ownProps);

  return {
    isLoading: clientsSelectors.isLoading(state),
    clientId,
    client: clientsSelectors.getClient(state),
    currentUserId: getUserId(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  getClient: clientActionCreators.GetClient,
};

export default connect(mapStateToProps, mapDispatchToProps)(LocalizedErrorPage);
